import React, { useState } from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { FormFieldProps, SelectionExtraProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import ChoiceChips from "../../selection/choiceSelection";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function ChoiceChipsFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, field, value, handleOnChangeCustom, readonly } = props;

  React.useImperativeHandle(props.fieldRef, () => ({
    change: (selectedItems: SelectionItem) => {
      onChangeHandler(selectedItems);
    },
  }));

  const extraProps = field.extraProps as SelectionExtraProps<T>;
  const [selectedItem, setSelectedItem] = useState<SelectionItem | undefined>(
    extraProps.items?.find((x) => x.id === value)
  );

  React.useEffect(() => {
    if (selectedItem?.id !== value) setSelectedItem(extraProps.items?.find((x) => x.id === value));
  }, [value, extraProps.items]);

  const onChangeHandler = (selectedItems: SelectionItem) => {
    const currSelectedItem = selectedItems;
    setSelectedItem(currSelectedItem);

    handleOnChangeCustom(
      name,
      currSelectedItem?.id as number,
      true,
      extraProps.referenceFieldName ? (extraProps.referenceFieldName as string) : undefined,
      (currSelectedItem?.value as string) ?? null
    );
  };

  return readonly ? (
    <ReadOnlyField label={props.field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {selectedItem?.value}
    </ReadOnlyField>
  ) : (
    <ChoiceChips
      title={props.field.label}
      items={extraProps.items ?? []}
      value={extraProps.hideSelection ? undefined : selectedItem}
      onChange={onChangeHandler}
      disabled={props.disabled}
      isReadOnly={props.readonly}
      className={field.classes?.input}
      disabledItems={extraProps.disabledItems}
    />
  );
}

export default ChoiceChipsFormField;
